import * as _ from 'lodash';

import * as angular from 'angular';

import * as api from '../../../api/api.service';

import { Puck } from '../../../impact/impact.type';

class SavingsPuckRowsCtrl {
  static bindings = {
    account: '<',
    featureList: '<',
    rfp: '<',
    offerId: '<',
    tierId: '<',
    pucks: '<',
    usePrimaryEquivalentCrosses: '<',
    masterPlanId: '<',
    initPuckApi: '&'
  };

  account;
  featureList;
  rfp;
  offerId;
  tierId;
  pucks;
  usePrimaryEquivalentCrosses;
  masterPlanId;
  initPuckApi;

  cachedPucks;

  pucksByRow; // check that pucksByRow works correctly for buyer side

  activePuck;
  activePuckRowNumber;
  activePuckColumnNumber;
  caretPosition;

  constructor(
    private NavMessages,
    private OfferImpactService,
    private api: api.IApiService
  ) {
    'ngInject';
  }

  $onInit() {
    this.initPuckApi({
      $event: {
        api: {
          closePuck: () => {
            // console.log('closing puck...');
            this.closePuck();
          }
        }
      }
    });
  }

  $onChanges(changes) {
    // console.log(changes);

    if (changes.pucks) {
      // console.log(changes.pucks);
      this.updatePuckRows(this.pucks);
    }
  }

  /**
   * For buyer side, we need to actively watch properties on the list of pucks (i.e. to see if the status changes)
   *
   * Any time the data for a member is updated, update the overview with the new data
   */
  $doCheck() {
    if (this.account.isSeller) {
      return false;
    }

    if (!angular.equals(this.cachedPucks, this.pucks)) {
      // console.log('Puck Rows: Pucks updated.');

      this.cachedPucks = angular.copy(this.pucks);

      this.updatePuckRows(this.pucks);
    }
  }

  isPuckOpenForRow(rowNumber) {
    return this.activePuckRowNumber == rowNumber;
  }

  getOffset(el) {
    // el = el.getBoundingClientRect();
    return {
      left: el.offsetLeft,
      top: el.offsetTop,
      width: el.clientWidth
    };
  }

  openPuck($event, puckClass) {
    let puck = $event.puck;

    this.activePuck = $event.puck;
    this.activePuckRowNumber = $event.rowNumber;
    this.activePuckColumnNumber = $event.columnNumber;

    let element = document.querySelector(puckClass);
    const detailsCaretWidth = 36;
    let elementLeftOffset = this.getOffset(element).left;
    let savingsPuckCenter = this.getOffset(element).width / 2;

    this.caretPosition =
      elementLeftOffset + savingsPuckCenter - detailsCaretWidth;

    window.addEventListener('resize', () => {
      elementLeftOffset = this.getOffset(element).left;
      savingsPuckCenter = this.getOffset(element).width / 2;

      this.caretPosition =
        elementLeftOffset + savingsPuckCenter - detailsCaretWidth;
    });
  }

  closePuck() {
    delete this.activePuck;
    delete this.activePuckRowNumber;
    delete this.activePuckColumnNumber;
  }

  classToPointToPuck() {
    var retVal = {};
    var className = 'pointingToPuck' + (this.activePuckColumnNumber + 1);

    retVal[className] = true;

    return retVal;
  }

  private updatePuckRows(pucks: Puck[]) {
    if (!pucks || pucks.length == 0) {
      this.pucksByRow = [];
    }

    // For debugging only - show them in order
    // var secondSort = pucks;

    // First sort all of the pucks alphabetically.
    var firstSort = _.sortBy(pucks, 'name');
    var secondSort = this.account.isBuyer
      ? this.sortByStatus(firstSort)
      : this.sortBySpend(firstSort);

    var index = 0;

    var grouped = _.groupBy(secondSort, () => {
      var group = Math.floor(index / 4);
      index++;

      return group;
    });

    // Now we have to do some special shenanigans because we get back an object but ng-repeat doesn't iterate over
    // objects with numbers for keys the way we want. That's because it sorts the keys like they are names.
    var groupedWithPaddedKeys = {};

    _.each(grouped, (value, key) => {
      key = String('00000' + key).slice(-5);
      groupedWithPaddedKeys[key] = value;
    });

    this.pucksByRow = groupedWithPaddedKeys;
  }

  sortBySpend(pucks) {
    return _.sortBy(pucks, (puck: any) => {
      if (
        puck.savings == null ||
        (puck.savings === 0 &&
          (puck.continuedSpend == null || puck.continuedSpend === 0))
      ) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  sortByStatus(pucks) {
    // Sort by the status as well. Because Lo-Dash's sort is stable, this should give us alphabetical sorts
    // within each status group.
    let sortedPucks = _.sortBy(pucks, (puck: any) => {
      if (
        puck.activeSellerImpact &&
        puck.activeSellerImpact.inclusionStatus === 'In'
      ) {
        return 0;
      } else if (
        puck.activeSellerImpact &&
        puck.activeSellerImpact.inclusionStatus === 'Out'
      ) {
        return 2;
      } else {
        // Undecided (also used for when we don't have a status)
        return 1;
      }
    });

    // console.log('Sorted by status:');
    // console.log(sortedPucks);

    return sortedPucks;
  }
}

export const SavingsPuckRowsComponent = {
  template: require('./savingsPuckRows.component.html'),
  controller: SavingsPuckRowsCtrl,
  bindings: SavingsPuckRowsCtrl.bindings
};
